
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return require("private-next-pages/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login"])
      });
    }
  